/* eslint-disable */
import React, {useState} from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Form,
  Label,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import { useTranslation } from "react-i18next";

const Login2faModal = (props) => {
  const { t } = useTranslation();
  const { login2faModal } = props.state;

  const preventJump = (e) => {
    e.preventDefault();
    toggle();
  };

  const toggle = () => {
    props.dispatch({
      type: "layout/save",
      payload: {
        login2faModal: false,
      },
    });
  };

  const submitErrCallback = (clear, code, msg) => {
    console.log(code, msg);

    setGcode({
      status: "danger",
      msg: t("Verify code is required!"),
    });
  };


    const submitSuccCallback = async () => {
     props.dispatch({
       type: "layout/save",
       payload: {
         login2faModal: false,
         is_login: true,
       },
     });
    };


  const [gcode, setGcode] = useState({
    status: "",
    msg: "",
    value: "",
  });

  // 处理表单输入
  const onChange = async (elmName, event) => {
    switch (elmName) {
      case "gcode":
        setGcode({
          status: "",
          msg: "",
          value: event.target.value,
        });
        if(event.target.value.length === 6 && verifyGcode(event.target.value)) {
           let values = {
             gcode: event.target.value,
             type: "2fa",
           };
            await props.dispatch({
              type: "layout/GaVerify",
              payload: values,
              errorCallback: submitErrCallback,
              successCallback: submitSuccCallback,
            });
        }
    }
  };

  //  失去焦点
  const onBlur = (elmName, event) => {
    switch (elmName) {
      case "gcode":
        verifyGcode(event.target.value);
    
    }
  };

  const verifyGcode = (gcode) => {
    if (!gcode) {
      setGcode({
        status: "danger",
        msg: t("Verify code is required!"),
      });
      return false;
    }

    if (!/^[0-9]{6}$/.test(gcode)) {
      setGcode({
        status: "warning",
        msg: t("Only rquires 6 digits number"),
      });
      return false;
    }
    setGcode({
      status: "success",
      msg: "",
      value: gcode,
    });

    return true;
  };

  // 提交表单
  const submit = async (e) => {
    e.preventDefault();
    let values = {
      gcode: gcode.value,
      type:"2fa",
    };

    if (!gcode.msg &&  gcode.value) {
      try {
        await props.dispatch({
          type: "layout/GaVerify",
          payload: values,
          errorCallback: submitErrCallback,
          successCallback: submitSuccCallback,
        });
      } catch (err) {
        console.log(err);
      }
    } 
  };

  return (
    <div>
      <Row>
        <Modal
          isOpen={login2faModal}
          toggle={toggle}
          className="modal-fullscreen-sm-down modal4 custom-modal"
          size="md"
        >
          <ModalBody>
            <Row>
              <Col>
                <div className="modal-bg">
                  <h5 className="font-light text-info-gradiant">
                    {t("Please enter your Google verification code")}
                  </h5>
                  <Form className="m-t-30">
                    <Row className="row">
                      <Col lg="12">
                        <FormGroup
                          className={gcode.status ? "has-" + gcode.status : ""}
                        >
                          <Input
                            className={
                              gcode.status
                                ? "form-control mb-2 form-control-" +
                                  gcode.status
                                : "form-control mb-2 "
                            }
                            type="text"
                            placeholder={t("GA verification code")}
                            value={gcode.value}
                            onChange={onChange.bind(this, "gcode")}
                            onBlur={onBlur.bind(this, "gcode")}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="col-lg-12 d-flex no-block justify-content-center">
                        <Button
                          type="submit"
                          className="btn btn-md btn-info-gradiant text-white btn-arrow"
                          onClick={submit}
                        >
                          <span>
                            {t("Confirm")} <i className="ti-arrow-right"></i>
                          </span>
                        </Button>{" "}
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
              <a
                href="#"
                className="close-btn d-flex align-items-center justify-content-center"
                data-bs-dismiss="modal"
                aria-hidden="true"
                onClick={preventJump}
              >
                ×
              </a>
            </Row>
          </ModalBody>
        </Modal>
      </Row>
    </div>
  );
};

export default Login2faModal;
